exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attempt-list[data-v-8ad30704] {\n  list-style: none;\n}\nh4[data-v-8ad30704] {\n  border-left: solid 1px #8f8f8f;\n}", ""]);

// exports
